
import { deepCopy } from "@/utils";
/**
 * 用于存储控制器
 */
const pendingMap = new Map()

/**
 * 创建各请求唯一标识
 * @param config
 * @returns
 */

function createRequestKey(config) {
  const keyData = deepCopy(config, {})
  if (keyData?.data) {
    delete keyData.data?.sign;
    delete keyData.data?.nonce
    delete keyData.data?.timestamp
  }
  return `${keyData?.method}_${keyData?.url}_${JSON.stringify(keyData?.data)}`;
}

export class AbortAxios {
  addPending(config) {
    this.removePending(config)
    const requestKey = createRequestKey(config)
    const abortController = new AbortController()
    config.signal = abortController.signal
    if (!pendingMap.has(requestKey)) {
      pendingMap.set(requestKey, abortController)
    }
  }

  removePending(config) {
    const requestKey = createRequestKey(config)
    if (pendingMap.has(requestKey)) {
      const abortController = pendingMap.get(requestKey)
      abortController?.abort()
      pendingMap.delete(requestKey)
    }
  }

  removeAllPending() {
    pendingMap.forEach((abortController) => {
      abortController.abort()
    })
    this.clear()
  }

  clear() {
    pendingMap.clear()
  }
}
